import * as React from "react";
import { forwardRef } from "react";
const SvgLogoSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 27 27", width: 21, height: 21, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}")), /* @__PURE__ */ React.createElement("path", { className: "cls-1", d: "m17.45,13.68c0,2.76-.55,4.88-2.25,6.59-1.88,1.89-4.1,2.42-8.18,2.42h-2.16v4.31h1.89c6.17,0,9.28-1.02,11.98-3.63,2.69-2.6,3.4-5.58,3.4-10.31V0h-4.69v13.68h0Z" }));
const ForwardRef = forwardRef(SvgLogoSmall);
export { ForwardRef as ReactComponent };
